<template>
    <div class="container section-menu-page">
        <div class="section-title-wrap">
            <h2 class="section-title">{{ labels.title }}</h2>
        </div>
        <div>
            <div class="admin-home-card table-corporate-body main-menu-scroll-shell">
                <!-- ===== SPINNER DE CARGA ===== -->
                <div v-if="isLoading" class="table-corporate-loading-state">
                    <div class="table-corporate-empty-card">
                        <div class="modern-spinner">
                            <div class="spinner-ring"></div>
                            <div class="spinner-ring"></div>
                            <div class="spinner-ring"></div>
                        </div>
                        <p class="mt-2 mb-0">Cargando...</p>
                    </div>
                </div>

                <!-- ===== CONTENIDO ===== -->
                <b-container v-else style="padding: 18px 40px 40px; height: 100%;">
                    <!-- Grid de botones en columnas verticales -->
                    <div v-if="visibleSubmenus.length > 0" class="menu-grid">
                        <div
                            v-for="subMenu in visibleSubmenus"
                            :key="subMenu.id || subMenu.ruta"
                            class="menu-grid-item"
                        >
                            <div class="menu-item-wrapper">
                                <button
                                    type="button"
                                    class="md-card admin-menu-card-button"
                                    @click="goToRoute(subMenu)"
                                >
                                    <div>
                                        <div>
                                            <div class="md-title-tarjeta">
                                                <span>{{ subMenu?.nombre }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                                <!-- Descripción fija siempre visible -->
                                <div class="div-description-fixed">
                                    <i class="fas fa-info-circle info-icon"></i>
                                    <span class="description-text">{{ subMenu?.descripcion || subMenu?.nombre }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Si no hay submenús, mostrar opciones por defecto -->
                    <div v-else class="menu-grid">
                        <div
                            v-for="item in defaultItems"
                            :key="item.id"
                            class="menu-grid-item"
                        >
                            <div class="menu-item-wrapper">
                                <button
                                    type="button"
                                    class="md-card admin-menu-card-button"
                                    @click="goToRoute(item)"
                                >
                                    <div>
                                        <div>
                                            <div class="md-title-tarjeta">
                                                <span>{{ item.nombre }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                                <div class="div-description-fixed">
                                    <i class="fas fa-info-circle info-icon"></i>
                                    <span class="description-text">{{ item.descripcion || item.nombre }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
import SubMenu from '../../services/SubMenu'; 
import Menu from '../../services/Menu';

export default {
    name: "Consolidacion",
    data: () => ({
        listaSubMenu: [],
        isLoading: true,
        error: false,
        menuId: 5 // ID del menú de Consolidación
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Consolidación",
                    reclasifica: "RECLASIFICA",
                    reclasificad: "RECLASIFICACION DE SALDOS DE BALANCE",
                    noData: "No hay opciones disponibles",
                    error: "Error al cargar los datos",
                    balance: "BAL",
                    balanceDesc: "BALANCE GENERAL - COMPARATIVO - CONSOLIDADO",
                    esf: "ESF",
                    esfDesc: "SITUACION FINANCIERA - COMPARATIVO - CONSOLIDADO",
                    eri: "ERI",
                    eriDesc: "RESULTADO INTEGRAL",
                    efe: "EFE",
                    efeDesc: "FLUJO DE EFECTIVO",
                    ecp: "ECP",
                    ecpDesc: "CAMBIO EN EL PATRIMONIO",
                    eliminaciones: "ELIMINACIONES",
                    eliminacionesDesc: "ELIMINACION DE SALDOS",
                    topside: "TOPSIDE",
                    topsideDesc: "AJUSTES TOPSIDE"
                }
            } else {
                return {
                    title: "Consolidation",
                    reclasifica: "RECLASSIFY",
                    reclasificad: "RECLASSIFY ACCOUNTING STATEMENT",
                    noData: "No options available",
                    error: "Error loading data",
                    balance: "BAL",
                    balanceDesc: "GENERAL BALANCE - COMPARATIVE - CONSOLIDATED",
                    esf: "ESF",
                    esfDesc: "FINANCIAL SITUATION - COMPARATIVE - CONSOLIDATED",
                    eri: "ERI",
                    eriDesc: "COMPREHENSIVE INCOME",
                    efe: "EFE",
                    efeDesc: "CASH FLOW",
                    ecp: "ECP",
                    ecpDesc: "CHANGES IN EQUITY",
                    eliminaciones: "ELIMINACIONES",
                    eliminacionesDesc: "ELIMINATION OF BALANCES",
                    topside: "TOPSIDE",
                    topsideDesc: "TOPSIDE ADJUSTMENTS"
                }
            }
        },
        visibleSubmenus() {
            return this.listaSubMenu.length > 0 ? this.listaSubMenu : []
        },
        defaultItems() {
            // Opciones por defecto en caso de que no haya submenús
            return [
                {
                    id: "balance",
                    nombre: this.labels.balance,
                    descripcion: this.labels.balanceDesc,
                    ruta: "/balanceNiif"
                },
                {
                    id: "esf",
                    nombre: this.labels.esf,
                    descripcion: this.labels.esfDesc,
                    ruta: "/reporteEsf"
                },
                {
                    id: "eri",
                    nombre: this.labels.eri,
                    descripcion: this.labels.eriDesc,
                    ruta: "/reporteEri"
                },
                {
                    id: "efe",
                    nombre: this.labels.efe,
                    descripcion: this.labels.efeDesc,
                    ruta: "/reporteEfe"
                },
                {
                    id: "ecp",
                    nombre: this.labels.ecp,
                    descripcion: this.labels.ecpDesc,
                    ruta: "/reporteEcp"
                },
                {
                    id: "eliminaciones",
                    nombre: this.labels.eliminaciones,
                    descripcion: this.labels.eliminacionesDesc,
                    ruta: "/eliminaciones"
                },
                {
                    id: "topside",
                    nombre: this.labels.topside,
                    descripcion: this.labels.topsideDesc,
                    ruta: "/ajustesTopside"
                },
                {
                    id: "reclasifica",
                    nombre: this.labels.reclasifica,
                    descripcion: this.labels.reclasificad,
                    ruta: "/reclasificaBalance"
                }
            ]
        }
    },
    methods: {
        /**
         * Resuelve la ruta correcta a partir del objeto subMenu
         */
        resolveRoute(subMenu) {
            const rawPath = String(subMenu?.ruta || "").trim()
            const rawName = String(subMenu?.nombre || "").trim().toLowerCase()
            
            // Si tiene ruta definida, normalizarla
            if (rawPath) {
                let normalizedPath = rawPath.startsWith("/") ? rawPath : `/${rawPath}`
                normalizedPath = normalizedPath.replace(/\s/g, '')
                
                // MAPEO CORRECTO DE RUTAS
                const routeMapping = {
                    '/reporteecp': '/reporteEcp',
                    '/reporteECP': '/reporteEcp',
                    '/ecpreporte': '/reporteEcp',
                    '/ecpReporte': '/reporteEcp',
                    '/ecp': '/reporteEcp',
                    '/cambioenelpatrimonio': '/reporteEcp',
                    '/reporteefe': '/reporteEfe',
                    '/reporteEFE': '/reporteEfe',
                    '/efereporte': '/reporteEfe',
                    '/efe': '/reporteEfe',
                    '/flujodeefectivo': '/reporteEfe',
                    '/reporteori': '/reporteOri',
                    '/reporteORI': '/reporteOri',
                    '/orireporte': '/reporteOri',
                    '/ori': '/reporteOri',
                    '/balance': '/balanceNiif',
                    '/balanceniif': '/balanceNiif',
                    '/esf': '/reporteEsf',
                    '/reporteesf': '/reporteEsf',
                    '/eri': '/reporteEri',
                    '/reporteeri': '/reporteEri',
                    '/eliminaciones': '/eliminaciones',
                    '/topside': '/ajustesTopside',
                    '/ajustestopside': '/ajustesTopside',
                    '/reclasifica': '/reclasificaBalance',
                    '/reclasificabalance': '/reclasificaBalance'
                }
                
                const normalizedLower = normalizedPath.toLowerCase()
                if (routeMapping[normalizedLower]) {
                    return routeMapping[normalizedLower]
                }
                
                const existingRoute = this.$router.getRoutes().find(route => 
                    route.path === normalizedPath
                )
                if (existingRoute) {
                    return normalizedPath
                }
                
                return normalizedPath
            }
            
            // Mapeo por nombre (fallback)
            const nameMapping = {
                'balance general': '/balanceNiif',
                'balance': '/balanceNiif',
                'bal': '/balanceNiif',
                'situacion financiera': '/reporteEsf',
                'esf': '/reporteEsf',
                'resultado integral': '/reporteEri',
                'eri': '/reporteEri',
                'flujo de efectivo': '/reporteEfe',
                'efe': '/reporteEfe',
                'cambio en el patrimonio': '/reporteEcp',
                'ecp': '/reporteEcp',
                'eliminaciones': '/eliminaciones',
                'eliminacion de saldos': '/eliminaciones',
                'topside': '/ajustesTopside',
                'ajustes topside': '/ajustesTopside',
                'reclasifica': '/reclasificaBalance',
                'reclasificacion': '/reclasificaBalance',
                'general balance': '/balanceNiif',
                'financial situation': '/reporteEsf',
                'comprehensive income': '/reporteEri',
                'cash flow': '/reporteEfe',
                'changes in equity': '/reporteEcp',
                'eliminations': '/eliminaciones',
                'balance elimination': '/eliminaciones',
                'topside adjustments': '/ajustesTopside',
                'reclassify': '/reclasificaBalance',
                'reclassification': '/reclasificaBalance'
            }
            
            if (nameMapping[rawName]) {
                return nameMapping[rawName]
            }
            
            for (const [key, route] of Object.entries(nameMapping)) {
                if (rawName.includes(key) || key.includes(rawName)) {
                    return route
                }
            }
            
            console.warn(`No se pudo resolver la ruta para: ${rawName}`)
            return null
        },

        goToRoute(subMenu) {
            let targetRoute = null
            
            if (typeof subMenu === 'object' && subMenu !== null) {
                targetRoute = this.resolveRoute(subMenu)
            } else if (typeof subMenu === 'string') {
                targetRoute = subMenu
            }
            
            if (!targetRoute) {
                console.error('Ruta no válida:', subMenu)
                this.$toast?.error('La ruta no es válida')
                return
            }
            
            let finalRoute = targetRoute.startsWith('/') ? targetRoute : `/${targetRoute}`
            finalRoute = finalRoute.replace(/\s/g, '')
            
            console.log('Intentando navegar a:', finalRoute)
            
            const allRoutes = this.$router.getRoutes()
            
            let routeExists = allRoutes.some(route => route.path === finalRoute)
            
            if (!routeExists) {
                const routeByName = allRoutes.find(route => {
                    if (finalRoute === '/reporteEcp' || finalRoute.includes('ecp') || finalRoute.includes('Ecp')) {
                        return route.name === 'reporteEcp' || route.name === 'ecpReporte'
                    }
                    if (finalRoute === '/reporteEfe' || finalRoute.includes('efe') || finalRoute.includes('Efe')) {
                        return route.name === 'reporteEfe'
                    }
                    if (finalRoute === '/reporteOri' || finalRoute.includes('ori') || finalRoute.includes('Ori')) {
                        return route.name === 'reporteOri' || route.name === 'oriReporte'
                    }
                    return route.path === finalRoute
                })
                
                if (routeByName) {
                    console.log('Encontrada ruta por nombre:', routeByName.path)
                    this.$router.push({ path: routeByName.path })
                    return
                }
            }
            
            const routeExistsFinal = this.$router.getRoutes().some(route => route.path === finalRoute)
            
            if (!routeExistsFinal) {
                console.error(`La ruta ${finalRoute} no existe en el router`)
                console.log('Rutas disponibles:', allRoutes.map(r => r.path))
                this.$toast?.error(`La ruta ${finalRoute} no está disponible`)
                return
            }
            
            this.$router.push({ path: finalRoute })
        },

        async cargarDatos() {
            this.isLoading = true;
            this.error = false;
            
            try {
                const menusResponse = await Menu.getAllMenu()
                const menus = menusResponse?.data?.listMenu || []
                const consolidacionMenu = menus.find((menu) => {
                    const route = String(menu?.ruta || "").toLowerCase()
                    const name = String(menu?.nombre || "").toLowerCase()
                    return route === "consolidacion" || 
                           route === "/consolidacion" || 
                           name === "consolidacion" ||
                           name === "consolidation"
                })
                
                const menuId = consolidacionMenu?.id || this.menuId
                console.log('Menu ID usado:', menuId)
                
                const res = await SubMenu.subMenuByMenuByRol(menuId, this.$store.state.userRole)
                const submenus = res?.data?.submenus || []
                
                this.listaSubMenu = submenus.map(item => {
                    const resolvedRoute = this.resolveRoute(item)
                    return {
                        ...item,
                        nombre: item?.nombre || 'Sin nombre',
                        descripcion: item?.descripcion || 'Sin descripción',
                        ruta: resolvedRoute || item?.ruta || ''
                    }
                }).filter(item => item.ruta)
                
                console.log('Submenús cargados:', this.listaSubMenu)
                
            } catch (err) {
                console.error('Error al cargar datos:', err)
                this.error = true
                this.$toast?.error(this.labels.error)
            } finally {
                this.isLoading = false
            }
        }
    },
    mounted() {
        this.cargarDatos()
    },
    // Reseteamos el estado al salir del componente
    beforeDestroy() {
        this.isLoading = false
        this.listaSubMenu = []
    }
}
</script>

<style src="../main.css"></style>